module.exports = __webpack_public_path__ + "img/file10.ac485598.png";